module.exports = __webpack_public_path__ + "media/images/jero-iphone-6419d41ae77dd86bd65b7ef25c742268.webp";